// extracted by mini-css-extract-plugin
export var body = "card-module--body--ff78e";
export var card = "card-module--card--656f0";
export var cardLink = "card-module--card-link--91f81";
export var content = "card-module--content--8bb39";
export var detailPill = "card-module--detail-pill--745fd";
export var detailPillBooked = "card-module--detail-pill--booked--a4a80";
export var detailPillCancelled = "card-module--detail-pill--cancelled--d9f89";
export var detailPillRescheduled = "card-module--detail-pill--rescheduled--8f49f";
export var image = "card-module--image--e917c";
export var title = "card-module--title--dc06d";